module.exports = __webpack_public_path__ + "media/Video 87.ebbf730c.mp4";